import {
  CalculCodeStateKeys,
  CalculContextState,
  ProjectContextState,
  ProjectDocument,
  ProjectDocumentFolder
} from '@batical/types/src'
import { ProjetCommon_Address } from '@batical/types/src/ProjectCommonState'
import { CalculsType } from './CalculsType'
export function setSection(section_code: string) {
  return {
    type: CalculsType.DEFINE_SECTION,
    payload: { section_code }
  }
}

export function setCalcul(calcul_code: CalculCodeStateKeys) {
  return {
    type: CalculsType.DEFINE_CALCUL,
    payload: { calcul_code }
  }
}

export function reset() {
  return {
    type: CalculsType.RESET
  }
}

export function doCalcul(calcul_code?: CalculCodeStateKeys) {
  return {
    type: CalculsType.DO_CALCUL,
    payload: { calcul: calcul_code }
  }
}

export function replaceContext(value: CalculContextState, code?: string) {
  return {
    type: CalculsType.REPLACE_STATE,
    payload: { value, calcul: code }
  }
}

export function updateContextValue(
  key: string,
  value: string | number | boolean | null | CalculContextState,
  calcul_code: string,
  do_calcul: boolean = true
) {
  return {
    type: CalculsType.UPDATE_CONTEXT_VALUE,
    payload: { key, calcul: calcul_code, value, do_calcul }
  }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function updateContext(value: { [key: string]: string | number | any }, calcul_code: string) {
  return {
    type: CalculsType.UPDATE_CONTEXT,
    payload: { calcul: calcul_code, value }
  }
}

export function loadContext(context: CalculContextState | ProjectContextState) {
  return {
    type: CalculsType.LOAD_CONTEXT,
    payload: { context }
  }
}

// PCUSTOM project actions
export function cleanCustomProject() {
  return {
    type: CalculsType.CLEAN_CUSTOM_PROJECT
  }
}

export function addCalculCustomProject(calcul: CalculContextState, section: string, title: string) {
  return {
    type: CalculsType.ADD_CALCUL_CUSTOM_PROJECT,
    payload: { calcul, section, title }
  }
}

export function removeCalculCustomProject(id: string) {
  return {
    type: CalculsType.REMOVE_CALCUL_CUSTOM_PROJECT,
    payload: id
  }
}

export function updateProjectName(name: string) {
  return {
    type: CalculsType.UPDATE_PROJECT_NAME,
    payload: name
  }
}

export function updateProjectDescription(description: string) {
  return {
    type: CalculsType.UPDATE_PROJECT_DESCRIPTION,
    payload: description
  }
}

export function updateProjectAddress(address: string | null) {
  return {
    type: CalculsType.UPDATE_PROJECT_ADDRESS,
    payload: address
  }
}

export function updateProjectAddressComponents(addressComponents: ProjetCommon_Address | null) {
  return {
    type: CalculsType.UPDATE_PROJECT_ADDRESS_COMPONENTS,
    payload: addressComponents
  }
}

export function updateProjectAvancement(avancement: string) {
  return {
    type: CalculsType.UPDATE_PROJECT_AVANCEMENT,
    payload: avancement
  }
}

export function addDocumentFolder(folder: ProjectDocumentFolder) {
  return {
    type: CalculsType.ADD_DOCUMENT_FOLDER,
    payload: folder
  }
}

export function updateDocumentFolder(folder: Partial<ProjectDocumentFolder> & { id: string }) {
  return {
    type: CalculsType.UPDATE_DOCUMENT_FOLDER,
    payload: folder
  }
}

export function removeDocumentFolder(id: string) {
  return {
    type: CalculsType.REMOVE_DOCUMENT_FOLDER,
    payload: id
  }
}

export function addDocument(doc: ProjectDocument, folderId: string) {
  return {
    type: CalculsType.ADD_DOCUMENT,
    payload: { doc, folderId }
  }
}

export function updateDocument(doc: Partial<ProjectDocument> & { id: string }, folderId: string) {
  return {
    type: CalculsType.UPDATE_DOCUMENT,
    payload: { doc, folderId }
  }
}

export function removeDocument(id: string, folderId: string) {
  return {
    type: CalculsType.REMOVE_DOCUMENT,
    payload: { id, folderId }
  }
}
